import { useCallback, useState } from 'react'
import type { CatalogProduct } from '../../types'
import { purchasabilityMessageByReason, resolveCatalogProductPurchasability } from '../../purchasability'

type Params = {
  addItem: (productId: string, quantity?: number) => Promise<boolean>
}

export const useCategoryAddToCartFeedback = ({ addItem }: Params) => {
  const [cartFeedback, setCartFeedback] = useState('')

  const handleAddToCart = useCallback(
    async (product: CatalogProduct) => {
      const purchasability = resolveCatalogProductPurchasability(product)
      if (!product._id) {
        setCartFeedback('Prodotto non disponibile')
        return
      }
      if (!purchasability.isPurchasable) {
        const reason = purchasability.reason
        setCartFeedback(reason ? purchasabilityMessageByReason[reason] : 'Prodotto non acquistabile')
        return
      }

      const ok = await addItem(product._id, 1)
      setCartFeedback(ok ? `${product.name} aggiunto al carrello` : 'Impossibile aggiungere al carrello')
    },
    [addItem],
  )

  return {
    cartFeedback,
    handleAddToCart,
  }
}
